var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerReferralsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 327,
    viewBox: "0 0 344 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_24773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.75,
    width: 343,
    height: 326,
    rx: 12,
    fill: "url(#paint0_linear_483_24773)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.037 233.842C115.037 233.806 115.038 233.77 115.038 233.734C115.038 214.212 99.3321 198.385 79.9577 198.385C65.5927 198.385 53.2465 207.087 47.8216 219.544C46.4455 219.305 45.0314 219.179 43.5878 219.179C29.9119 219.179 18.8252 230.351 18.8252 244.131C18.8252 257.912 29.9119 269.083 43.5878 269.083H116.973C126.66 269.083 134.513 261.17 134.513 251.409C134.513 241.647 126.66 233.734 116.973 233.734C116.318 233.734 115.673 233.772 115.037 233.842Z",
    fill: "url(#paint1_linear_483_24773)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.699 290.702C328.699 290.645 328.701 290.588 328.701 290.531C328.701 259.526 303.758 234.392 272.988 234.392C250.175 234.392 230.567 248.211 221.952 267.994C219.766 267.615 217.521 267.415 215.228 267.415C193.509 267.415 175.901 285.157 175.901 307.043C175.901 328.928 193.509 346.67 215.228 346.67H331.773C347.158 346.67 359.629 334.103 359.629 318.6C359.629 303.098 347.158 290.531 331.773 290.531C330.734 290.531 329.709 290.59 328.699 290.702Z",
    fill: "url(#paint2_linear_483_24773)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.085 288.34C167.652 357.892 59.4779 256.825 4.71253 363.09",
    stroke: "#292B2E",
    strokeWidth: 0.880302,
    strokeLinecap: "round",
    strokeDasharray: "4.3 4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.188 245.282C28.7947 305.617 111.69 395.114 -50.2561 445.747",
    stroke: "#292B2E",
    strokeWidth: 0.880302,
    strokeLinecap: "round",
    strokeDasharray: "3.86 3.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.381 284.117L223.462 266.06L267.71 234.641L227.381 284.117Z",
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.733585,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.381 284.117L231.989 271.915L267.62 234.66L227.381 284.117Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.733585,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.159 269.773L203.611 263.54C202.988 263.351 202.94 262.488 203.538 262.231L267.669 234.649L224.159 269.773Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.733585,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.599 277.782L231.989 271.845L267.619 234.66L257.442 277.265C257.352 277.641 256.974 277.872 256.599 277.782Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.733585,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.329 224.476L125.764 241.737L203.216 206.461L134.329 224.476Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.469 242.408C125.378 242.368 125.297 242.311 125.229 242.238C125.161 242.166 125.109 242.08 125.075 241.987C125.041 241.894 125.026 241.795 125.032 241.696C125.037 241.597 125.063 241.5 125.107 241.411L133.673 224.151C133.719 224.057 133.785 223.974 133.866 223.908C133.948 223.842 134.042 223.794 134.143 223.768L203.03 205.753C203.207 205.707 203.396 205.728 203.558 205.814C203.72 205.9 203.844 206.044 203.906 206.216C203.967 206.389 203.961 206.579 203.89 206.748C203.818 206.917 203.686 207.053 203.519 207.129L126.067 242.404C125.973 242.446 125.872 242.469 125.769 242.47C125.666 242.47 125.564 242.449 125.469 242.408ZM134.837 225.101L127.336 240.216L195.159 209.326L134.837 225.101Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.423 205.482L147.934 260.957L134.455 224.798L115.874 203.078L205.423 205.482Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.733585
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.113 223.973L137.462 232.704L204.828 205.689L134.113 223.973Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.267 236.09L137.158 232.907L127.002 241.212L138.267 236.09Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_483_24773",
    x1: 0.375,
    y1: 0.75,
    x2: 91.8327,
    y2: 386.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_483_24773",
    x1: 76.669,
    y1: 246.855,
    x2: 72.4779,
    y2: 216.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_483_24773",
    x1: 267.765,
    y1: 311.369,
    x2: 261.109,
    y2: 263.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_24773"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.75,
    width: 343,
    height: 326,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerReferralsMobile);
export default __webpack_public_path__ + "static/media/banner_referrals_mobile.c20812500206f45520d8b1ccc88dbbfe.svg";
export { ForwardRef as ReactComponent };